import React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { ArrowLeft } from 'assets/icons';
import { Affiliate1, Affiliate2, Affiliate3, WelcomeImage } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class SelectLevel extends React.Component<Props> {

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Registro',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});
	}

	render() {
		return (
			<div id="select-level">
				<section className="welcome">
					<img src={WelcomeImage} alt="Welcome" />
				</section>
				<main>
					<Link className="back-btn" to="/login">
						<img src={ArrowLeft} alt="Back" />
					</Link>

					<div className="content">
						<h1 className="title">¿Cómo deseas registrarte?</h1>
						<p>Seleccione su tipo de usuario</p>

						<div className="options">
							<OptionButton
								label="Médico veterinario"
								icon={Affiliate1}
								path="medic"
							/>
							<OptionButton
								label="Clínica veterinaria"
								icon={Affiliate2}
								path="clinic"
							/>
							<OptionButton
								label="Comercio / Servicio / Anunciante"
								icon={Affiliate3}
								path="business"
							/>
						</div>
					</div>
				</main>
			</div>
		)
	}
}

interface OptionButtonProps {
	icon: any
	label: string
	path: string
}

const OptionButton = ({ icon, label, path }: OptionButtonProps) => (
	<Link className="option-btn" to={path}>
		<img src={icon} alt={ label } />
		<span>{ label }</span>
	</Link>
)

export default connect()(SelectLevel);